<template>
  <div v-if="!isLeasing" class="is-flex is-justify-content-center af-footer">
    <a :href="$t('af:footer.link.privacy_policy')" target="_blank">{{
      $t("af:footer.title.privacy_policy")
    }}</a>
    <a :href="$t('af:footer.link.user_agreement')" target="_blank">{{
      $t("af:footer.title.user_agreement")
    }}</a>
    <a :href="$t('af:footer.link.instacash')" target="_blank"
      >{{ $t("af:footer.title.instacash") }}{{ year }}</a
    >
  </div>
  <div v-else class="is-flex is-justify-content-center af-footer">
    <a :href="$t('af:leasing_footer.link.privacy_policy')" target="_blank">{{
      $t("af:leasing_footer.title.privacy_policy")
    }}</a>
    <a :href="$t('af:leasing_footer.link.user_agreement')" target="_blank">{{
      $t("af:leasing_footer.title.user_agreement")
    }}</a>
    <a :href="$t('af:leasing_footer.link.instacash')" target="_blank"
      >{{ $t("af:leasing_footer.title.instacash") }}{{ year }}</a
    >
  </div>
</template>

<script>
export default {
  name: "TheFooter",
  computed: {
    year() {
      return new Date().getFullYear();
    },
    isLeasing() {
      return /^\/leasing.*/i.test(this.$route.path);
    },
  },
};
</script>

<style lang="scss" scoped>
.af-footer {
  padding: 20px;
}

a {
  color: #adb7c4;
  font-size: 12px;
  margin: 0 8px;

  .dealer-branding-wrapper & {
    color: var(--color-gray-text);
  }
}
</style>
